import { spreadSearchQuery } from "helpers/utilities"
import { get, put, post, del } from "../api_helper2"

const BASE_API_URL = `${process.env.REACT_APP_LABORATORY_ENDPOINT}/general-dashboard`

const getGeneralInformation = (query) => {
    let q = spreadSearchQuery(query)
    return get(`${BASE_API_URL}?${q}`)
}


export { getGeneralInformation }
